import type { Scene } from './sceneState.js';

/** Find the first LayerNode depth-first in a scene and return its scene node id plus layer id. */
export function findFirstLayerNodeIds(scene: Scene): { layerNodeId: string; layerId: string } | null {
  function visit(nodeId: string): { layerNodeId: string; layerId: string } | null {
    const node = scene.nodes[nodeId];
    if (!node) return null;
    if (node.kind === 'layer') return { layerNodeId: node.id, layerId: node.layerId };
    if (node.kind === 'frame') {
      for (const childId of node.childIds) {
        const found = visit(childId);
        if (found) return found;
      }
    }
    return null;
  }

  for (const rootId of scene.rootIds) {
    const found = visit(rootId);
    if (found) return found;
  }
  return null;
}
